<div class="container-md">
  <div class="mt-3 mb-3 ms-2">
    <div>
      <label class="fw-bold title" for="email"
        >{{ 'IDS_CHANGE_PASSWORD' | translate }}</label
      >
    </div>
    <div>
      <label class="mt-2" for="email"
        >{{ 'IDS_INSERT_EMAIL' | translate }}</label
      >
    </div>
    <form (ngSubmit)="onSubmit()" #emailForm="ngForm">
      <input
        type="email"
        id="email"
        required
        [(ngModel)]="resetPassword.email"
        name="email"
        class="form-control my-2"
      />
      @if(isEmailInvalid){
      <div class="error mb-2">
        <label for="email">{{'IDS_EMAIL_NOT_VALID' | translate }}</label>
      </div>
      } @if(emailSent){
      <div class="success my-2">
        <label for="email">{{'IDS_EMAIL_SENT' | translate}}</label>
      </div>
      }
      <div>
        <button
          type="submit"
          [disabled]="!emailForm.form.valid"
          class="btn-gold fw-bold px-3 text-uppercase my-2"
        >
          {{ 'IDS_GET_EMAIL' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
